<section class="c-section c-section--first u-no-pb" panel [isOpen]="true">
	<div class="c-section__header">
		<h2 class="c-section__title c-section__title--sm">{{ 'Partners.Title' | translate }}</h2>
	</div>
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell o-grid__cell--w-100">
				<p class="c-text c-text--wrap u-osb-lg" style="padding-top:10px;">{{ 'Partners.Intro' | translate }}</p>
			</div>
		</div>
		<div class="c-card u-osb-xl" style="margin-left:15px;margin-right:15px;">
			<div class="c-content">
				<form class="c-form">
					<div class="o-grid o-grid--wrap">
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up u-no-p c-header__cell@md-and-up">
							<div class="c-form__group c-form__group--icon u-no-m">
								<label for="partnerTerm" class="c-form__label u-sr-only">{{ 'Services.Other.Search_Placeholder' | translate }}</label>
								<i class="o-icon o-icon--search c-form__icon" aria-hidden="true"></i>
								<input type="text" id="partnerTerm" name="partnerTerm" class="c-form__input c-form__input--no-border c-header__input" placeholder="{{ 'Services.Other.Search_Placeholder' | translate }}" spellcheck="false" [(ngModel)]="vm.search.term" (ngModelChange)="onSearchChange($event)">
							</div>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up u-no-p c-header__cell">
							<div class="c-form__group u-no-m">
								<label for="partnerLang" class="c-form__label u-sr-only">{{ 'Services.Filter.Languages' | translate }}</label>
								<mat-select [(value)]="vm.search.lang" (closed)="vm.triggerSearch()" class="mat-select" id="partnerLang" placeholder="{{ 'Services.Filter.Languages' | translate }}" multiple data-md-container-class="mat-select-menu2">
									<mat-option *ngFor="let lang of vm.searchLanguages" [value]="lang">{{ ('Services.Language.' + lang) | translate }}</mat-option>
									<mat-select-trigger>{{ vm.getLanguagesText() }}</mat-select-trigger>
								</mat-select>
							</div>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up u-no-p c-header__cell">
							<div class="c-form__group u-no-m">
								<label for="partnerTypeOfAppointment" class="c-form__label u-sr-only">{{ 'Partners.Filter.Session_Type' | translate }}</label>
								<mat-select [(value)]="vm.search.typeOfAppointment" (closed)="vm.triggerSearch()" class="mat-select" id="partnerTypeOfAppointment" placeholder="{{ 'Subscription.Label.All_Sessions' | translate }}" data-md-container-class="mat-select-menu2">
									<mat-option [value]="null">
										{{ 'Subscription.Label.All_Sessions' | translate }}
									</mat-option>
									<mat-option *ngFor="let type of vm.typeOfAppointments" [value]="type">{{ ('Subscription.Label.' + type) | translate }}</mat-option>
								</mat-select>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
		<div class="o-grid o-grid--wrap" style="min-height:300px">
			<ng-container *ngIf="vm.services?.length">
				<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up o-grid__cell--w-33@lg-and-up c-cell c-cell--isolated" *ngFor="let service of vm.services">
					<card-service [service]="service" [therapyTranslations]="vm.therapyTranslations" [partnerMode]="true"></card-service>
				</div>
			</ng-container>
			<div class="o-grid__cell o-grid__cell--w-100" *ngIf="vm.loading">
				<loader-overlay [theme]="1" *ngIf="vm.isInitial"></loader-overlay>
				<div class="c-loader" *ngIf="!vm.isInitial"></div>
			</div>
			<div class="o-grid__cell o-grid__cell--w-100" *ngIf="!vm.isLast && !vm.loading && vm.services?.length">
				<div class="o-grid o-grid--center-h">
					<div class="o-grid__cell o-grid__cell--w-fixed u-ost-lg u-osb-lg">
						<a id="showMorePartnersButton" href="javascript:void(0)" (click)="vm.searchPartners(false)">{{ 'Services.Button.ShowMore' | translate }}</a>
					</div>
				</div>
			</div>
			<div class="o-grid__cell o-grid__cell--w-100" *ngIf="!vm.services?.length && !vm.loading && vm.initialized">
				<div class="c-card u-ost-md u-osb-md">
					<div class="c-content c-content--xxl">
						<item-no-content></item-no-content>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
